<script setup lang="ts">
const props = defineProps({ trekTitle: { type: String, required: true } });
const page = usePage().value;
interface Accommodation {
  categories?: {
    value?: string;
  };
  // Add other properties of the accommodation object if needed
}

const accommodation = computed(() => page?.accommodation ?? []);
const filterAccommodation = computed(() => {
  // Remove apostrophes from trekTitle
  const normalizedTrekTitle = props.trekTitle.replace(/'/g, "");

  //   console.log("Filtering accommodation with trekTitle:", normalizedTrekTitle);
  return accommodation.value.filter((acc: Accommodation) => {
    // Ensure acc.categories is an object
    if (acc.categories && typeof acc.categories === "object") {
      // Log the categories for debugging
      //   console.log("Checking categories for accommodation:", acc.categories);

      // Check if the 'value' property in acc.categories includes the normalized trekTitle
      const categoryValues = acc.categories.value;
      if (typeof categoryValues === "string") {
        const match = categoryValues
          .split(",")
          .map((title) => title.trim().replace(/'/g, ""))
          .includes(normalizedTrekTitle);
        //   console.log("Match found:", match);
        return match;
      }
    }
    return false;
  });
});
</script>

<template>
  <h3 v-if="filterAccommodation.length">Accommodation</h3>
  <section class="accommodation-wrap trek-page">
    <div
      v-for="(acc, index) in filterAccommodation"
      :key="index"
      class="accommodation btn from-left"
    >
      <div class="acc-image">
        <NuxtPicture
          v-if="acc?.accImage"
          loading="lazy"
          :src="acc?.accImage.url"
          :width="acc?.accImage.width"
          :height="acc?.accImage.height"
          :alt="acc?.accImage.alt"
          sizes="sm:100vw md:50vw lg:600px"
        />
      </div>
      <header>
        <h3>{{ acc.accommodation_title }}</h3>
        <h4>{{ acc.accommodation_location }}</h4>
      </header>
      <div class="acc-meta">
        <div v-html="acc.accommodation_desc" />
        <p>
          Meal basis: <strong>{{ acc.meal_type }}</strong>
        </p>
      </div>
    </div>
  </section>
</template>
